import useJwt from '@/auth/useJwt'


export const getShoppersId = (criteria, payload) => {
    return useJwt.post(`/shoppers/by-criteria/${criteria}`, payload)
}